const STORE_ZONES = {
  'Anna Nagar':   ['Main Entrance','Dining Hall','Counter','Kitchen Cam','Parking View','Restroom'],
  'T. Nagar':     ['Entry Gate','Juice Bar','Dining Area','Kitchen Cam','Front Desk','Storage'],
  'Adyar':        ['Front Door','Counter','Parking View','Dining Zone','Cold Storage','Billing'],
  'Velachery':    ['Entrance','Food Court','Restroom','Cold Storage','Billing Counter','Prep Area'],
  'Mylapore':     ['Takeaway','Main Hall','Storage','Front Counter','Kitchen Cam','Lobby'],
  'Nungambakkam': ['Main Door','Dine-in','Counter','Parking','Kitchen Cam','Restroom'],
  'Porur':        ['Entry','Hall','Kitchen','Billing','Parking','Service Area'],
  'Tambaram':     ['Main Gate','Dining','Takeaway','Kitchen','Cold Room','Lobby'],
  'Perambur':     ['Entrance','Food Area','Counter','Storage','Billing','Prep Zone'],
  'OMR':          ['Main Lobby','Food Court','Counter','Parking','Kitchen','Service Desk'],
  'Chromepet':    ['Main Gate','Dine-in','Counter','Kitchen','Cold Storage','Lobby'],
  'Guindy':       ['Lobby','Food Hall','Counter','Kitchen','Parking','Restroom'],
};

const pad = (n) => String(n).padStart(2, '0');

export function generateCams(storeName) {
  const zones = STORE_ZONES[storeName] || ['Entrance', 'Counter', 'Hall'];
  const seed  = storeName.charCodeAt(0);
  const hours = [8,9,10,11,12,13,14,15,16,17,18,19,21];
  const caps  = [];
  hours.forEach((h, si) => {
    const count = 5 + ((seed + si * 3) % 4);
    for (let i = 0; i < count; i++) {
      const m = ((seed * (i + 1) * 7 + si * 13) % 55) + 1;
      caps.push({
        zone:    zones[(si * 3 + i + seed) % zones.length],
        time:    `${pad(h)}:${pad(m)}`,
        count:   2 + ((seed + i * 5 + si * 7) % 22),
        date:    'Apr 7',
        storeName,
      });
    }
  });
  return caps;
}

export function camSlot(time) {
  const h = parseInt(time.split(':')[0], 10);
  if (h >= 19) return '19-22';
  return pad(h) + '-' + pad(h + 1);
}

export const TIME_SLOTS = [
  { key: 'all',   label: 'All Hours' },
  { key: '08-09', label: '08–09' }, { key: '09-10', label: '09–10' },
  { key: '10-11', label: '10–11' }, { key: '11-12', label: '11–12' },
  { key: '12-13', label: '12–13' }, { key: '13-14', label: '13–14' },
  { key: '14-15', label: '14–15' }, { key: '15-16', label: '15–16' },
  { key: '16-17', label: '16–17' }, { key: '17-18', label: '17–18' },
  { key: '18-19', label: '18–19' }, { key: '19-22', label: '19–22' },
];
